import { i18n } from '@/plugins/i18n'

const localizedMap = (baseKey, keys) => Object.defineProperties({}, Object.fromEntries(keys.map(key => [
  key,
  { enumerable: true, get: () => i18n.t(`${baseKey}.${key}`) }
])))

export const readablePlotDevelopment = localizedMap('enums.plotDevelopment', [
  'COVERED_AREA',
  'NOW',
  'NEAR_FUTURE',
  'RESTRICTED',
  'NONE',
  'UNKNOWN'
])

export const readablePlotType = localizedMap('enums.plotType', [
  'CONSTRUCTION',
  'EXPECTED',
  'BUSINESS'
])

export const readablePlotCondition = localizedMap('enums.plotCondition', [
  'power',
  'road',
  'water'
])
